<template>
  <div :class="['flex flex-col gap-1 p-3 border rounded-lg', containerClass]">
    <span
      v-for="item in items"
      :key="item"
      class="flex items-center gap-1 text-sm text-gray-700"
    >
      <Check class="w-5 text-teal-600" />
      <span>{{ item.label }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { Check } from 'lucide-vue-next'

const props = withDefaults(
  defineProps<{
    firstLabel: string
    secondLabel: string
    thirdLabel: string
    /** Background/border classes for the container; defaults to the teal look. */
    containerClass?: string
  }>(),
  {
    firstLabel: '',
    secondLabel: '',
    thirdLabel: '',
    containerClass: 'bg-teal-50 border-teal-100',
  }
)

const items = computed(() =>
  [props.firstLabel, props.secondLabel, props.thirdLabel]
    .filter((label) => label)
    .map((label) => ({ label }))
)
</script>

<style lang="postcss" scoped>
.giftcard-booking-icon-line {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
